import { render, staticRenderFns } from "./PlanRead3.vue?vue&type=template&id=aaf388f2&scoped=true"
import script from "./PlanRead3.vue?vue&type=script&lang=js"
export * from "./PlanRead3.vue?vue&type=script&lang=js"
import style0 from "./PlanRead3.vue?vue&type=style&index=0&id=aaf388f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf388f2",
  null
  
)

export default component.exports